import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../utils/axios';

export const fetchEligibleVatTrns = async () => {
  const { data } = await apiClient.get('/business-profiles/trns', { skipErrorSnackbar: true });
  const vatNumbers = Array.isArray(data?.vat_numbers) ? data.vat_numbers : [];
  return vatNumbers.map((vatNumber) => ({
    vat_number: vatNumber,
    label: vatNumber,
  }));
};

export const useGetEligibleVatTrnsHandler = ({ enabled = true } = {}) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['vat-trns'],
    queryFn: fetchEligibleVatTrns,
    enabled,
    refetchOnWindowFocus: true,
  });

  return {
    vatTrns: data ?? [],
    isLoading,
    isError,
  };
};
